import { useRef,useState } from "react";
import Footer from "../components/footer";
import Header from "../components/header";

export default function LibroReclamacionesPage(){

    const nameRef = useRef();
    const lastnameRef = useRef();
    const emailRef = useRef();
    const docRef = useRef();
    const [typeDoc ,setTypeDoc] = useState("DNI");
    const messageRef = useRef();
    const [issue, setIssue]  = useState("Queja");
    const correlative = `${new Date().getDate()} ${new Date().getFullYear()} `
    const fecha = new Date().toLocaleDateString();

    const onSubmit = (e) => {
        e.preventDefault();

        
        const body = encodeURIComponent(
            `Hola, deseo registrar mi ${issue} en el libro de reclamaciones.
            Nro: ${correlative} 
            Nombres: ${nameRef.current.value}
            Apellidos: ${lastnameRef.current.value}
            Tipo documento: ${typeDoc}
            Documento: ${docRef.current.value}
            Mensaje: ${messageRef.current.value}
            Tipo solicitud: ${issue}
            Fecha: ${fecha}`
        );
        const mailto = `mailto:c.quispe@devosinc.com?subject=Registro a Libro Reclamaciones 2G &body=${body}&cc=${emailRef.current.value}`;

        const a = document.createElement("a");
        a.href = mailto;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    return (
        <div>
            <Header />
            <form onSubmit={onSubmit}>

                <div className="px-4 py-10 md:p-20 grid grid-cols-1 lg:grid-cols-2 w-full md:w-1/2 gap-y-4 gap-x-2">
                    <div className="col-span-1 lg:col-span-2">
                        <p className="text-xl font-bold text-dgtitle">Libro de Reclamaciones</p>                    
                    </div>
                    
                    <div className="col-span-1 md:col-span-1">
                        <p className="text-lg font-semibold text-dgtitle ">Nombres</p>
                        <input required ref={nameRef} placeholder="Nombres" className="border-2 lg:w-3/4 w-full py-1 px-2 rounded"/>
                    </div>
                    <div className="col-span-1 md:col-span-1">

                        <p className="text-lg font-semibold text-dgtitle">Apellidos</p>
                        <input required ref={lastnameRef} placeholder="Apellidos" className="border-2 w-full lg:w-3/4 py-1 px-2 rounded"/>
                    </div>
                    <div className="col-span-1 ">
                        <p className="text-md font-semibold text-dgtitle text-lg
                        ">Correo electrónico</p>
                        <input type="email" required ref={emailRef} placeholder="Correo" className="border-2 w-full  rounded py-1 px-2"/>
                    </div>
                    <div className="col-span-1 flex flex-col gap-y-2 md:gap-0 ">
                        <p className="text-dgtitle font-semibold text-lg">Tipo de Documento</p>
                        <div>
                            <input defaultChecked={true} name="issueInpA" type="radio" checked={typeDoc === "DNI"} onChange={(v)=>setTypeDoc("DNI")} label="DNI" className="border-2"/>
                            <label for="issueInpA" className="ml-2" >DNI</label>
                        </div>
                        <div>
                            <input name="issueInpB" type="radio"  checked={typeDoc === "Carnet"} onChange={(v)=>setTypeDoc("Carnet")} label="Carnet Extranjeria" className="border-2 md:ml-4 lg:ml-0"/>
                            <label for="issueInpB" className="ml-2" >Carnet de Extranjeria</label>
                        </div>
                    </div>
                    <div>
                        <p className="text-lg font-semibold text-dgtitle">Documento</p>
                        <input ref={docRef} placeholder="Documento" className="border-2 py-1 px-2 w-full lg:w-3/4 rounded"/>
                    </div>
                    <div className="col-span-1">
                        <p className="text-dgtitle font-semibold text-lg">Tipo de solicitud</p>
                        <input name="issueInpC" type="radio" label="Queja" className="border-2" onChange={(v)=>setIssue("Queja")}  checked ={issue==="Queja"}/>
                        <label for="issueInpC" className="ml-2">Queja</label>
                        <input name="issueInpD" type="radio" label="Reclamo" className="border-2 ml-4" onChange={(v)=>setIssue("Reclamo")} checked={issue==="Reclamo"} />
                        <label for="issueInpD" className="ml-2">Reclamo</label>
                    </div>
                    <div className="col-span-1">
                        <textarea ref={messageRef} required className="border-2 p-2 w-full rounded" placeholder="Escriba su mensaje aquí"></textarea>
                    </div>
                    <div className="col-span-1 lg:col-span-2">
                        <button 
                            type="submit"
                            className=" text-lg border-2 rounded-full text-dgtitle border-dgtitle hover:bg-dgwhite hover:text-black  px-4 py-1 font-poppins shadow-lg"
                        >Enviar</button>
                    </div>
                </div>
            </form>
            <Footer />
        </div>
    )
}